export default __webpack_public_path__ + "a41c7e7fb208864b79e1cad674817974.png";